var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      ref: "staffScrollbar",
      staticClass: "scroll-box",
      attrs: { "element-loading-text": "拼命加载中" }
    },
    [
      _c(
        "div",
        { staticClass: "chat-content1" },
        [
          _vm.total != 0
            ? _c(
                "span",
                {
                  staticClass: "ohou",
                  staticStyle: { "text-align": "center" }
                },
                [
                  _vm.showMore
                    ? _c(
                        "span",
                        [
                          _c(
                            "center",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                "margin-top": "10px",
                                color: "#4996F6",
                                "font-size": "13px"
                              }
                            },
                            [_vm._v(" 向上滚动加载更多 ")]
                          )
                        ],
                        1
                      )
                    : _c(
                        "span",
                        [
                          _c(
                            "center",
                            {
                              staticStyle: {
                                "margin-bottom": "10px",
                                "margin-top": "10px",
                                color: "#4996F6",
                                "font-size": "13px"
                              }
                            },
                            [_vm._v(" 无更多记录 ")]
                          )
                        ],
                        1
                      )
                ]
              )
            : _vm._e(),
          _vm.total == 0 && !_vm.loading
            ? _c(
                "div",
                {
                  staticClass: "chat-complate",
                  staticStyle: { height: "100%" }
                },
                [
                  _c("span", { staticClass: "empty-text" }, [
                    _vm._v(_vm._s(_vm.emptyText))
                  ])
                ]
              )
            : _vm._e(),
          _vm._l(_vm.data, function(itemc, indexc) {
            return _c("div", { key: indexc }, [
              !itemc.mineMsg
                ? _c("div", { staticClass: "word" }, [
                    _c("div", { staticClass: "time" }, [
                      _c("div", { staticClass: "nick-name" }, [
                        _vm._v(_vm._s(itemc.nickName))
                      ]),
                      _c("span", [_vm._v(_vm._s(itemc.timestamp))])
                    ]),
                    _c("div", { staticClass: "main" }, [
                      _c("img", {
                        staticClass: "userImage",
                        attrs: { src: itemc.headUrl }
                      }),
                      _c(
                        "div",
                        { staticClass: "info", staticStyle: { flex: "1" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-start",
                                "align-items": "center",
                                height: "100%"
                              }
                            },
                            [_vm._t("left", null, { row: itemc })],
                            2
                          )
                        ]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "word-my" }, [
                    _c("div", { staticClass: "time" }, [
                      _c("div", { staticClass: "nick-name" }, [
                        _vm._v(_vm._s(itemc.nickName))
                      ]),
                      _c("span", [_vm._v(_vm._s(itemc.timestamp))])
                    ]),
                    _c("div", { staticClass: "main" }, [
                      _c(
                        "div",
                        { staticClass: "info", staticStyle: { flex: "1" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "flex-end",
                                "align-items": "center",
                                height: "100%"
                              }
                            },
                            [_vm._t("right", null, { row: itemc })],
                            2
                          )
                        ]
                      ),
                      _c("span", { staticClass: "userImage" }, [
                        _vm._v(_vm._s(_vm.getAvatarName(itemc.nickName)))
                      ])
                    ])
                  ])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }